"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
class AspectRatios {
    constructor({ buckets }) {
        this.buckets = buckets;
    }
}
AspectRatios.fromJSON = (json) => {
    const { buckets } = Object.assign({}, json);
    if (!Array.isArray(buckets)) {
        throw new Error('buckets should be array');
    }
    try {
        const _buckets = buckets.map(bucket => Bucket_1.default.fromJSON(bucket));
        return new AspectRatios({
            buckets: _buckets,
        });
    }
    catch (err) {
        throw new Error('.facets.aspectRatios must be a { buckets: { value: string; count: number }[]}');
    }
};
exports.default = AspectRatios;
